import { Button } from '@basqet-dashboard/common/components';
import { formatDocumentTitle, useNavigateTo } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

import { ReasonForRejection } from './reason-for-rejection';

const KycDeclined = ({ files }) => {
  const { navigateTo } = useNavigateTo();
  return (
    <div className="kyc__status">
      <div className="card kyc__status--rejected">
        <header className="card__header">
          <h3>Your Account Verification is Ongoing</h3>
          <p>
            Our payment gateway creates a safe, easy and fast way to do business with customers
            globally.
          </p>
        </header>
        <div className="card__body">
          <ListOfFiles files={files} />
        </div>
        <Button isFull onClick={() => navigateTo('/')}>
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

const ListOfFiles = ({ files = [] }) => {
  return (
    <ul className="files-list">
      {files.map((file, index) => (
        <File {...file} key={`list-of-rejected-files-${index}`} />
      ))}
    </ul>
  );
};

const File = ({ document_title, status, reference, kycUploadComments = [] }) => {
  const documentTitle = formatDocumentTitle(document_title);
  const isDeclined = status === 'DECLINED';
  return (
    <li className="files-list__item">
      <div className="files-list__item__title">
        <p>{documentTitle}</p>

        <span className={`files-list__item__status ${status.toLowerCase()} `}>{status}</span>
      </div>
      <div>
        {isDeclined && (
          <ReasonForRejection
            comments={kycUploadComments}
            reference={reference}
            documentTitle={documentTitle}
          />
        )}
      </div>
    </li>
  );
};

KycDeclined.propTypes = {
  files: PropTypes.array
};
ListOfFiles.propTypes = {
  files: PropTypes.array
};

File.propTypes = {
  document_title: PropTypes.string,
  status: PropTypes.string,
  kycUploadComments: PropTypes.array,
  reference: PropTypes.string
};

export { KycDeclined };
